import React, { useState, useEffect, useMemo, useCallback } from 'react';
//ANTD
import { Button, Checkbox, Spin } from 'antd';
//API
import tourPrevAPI from '../../../../API/tour.prev.api';
//COMPONENTS
import TourItem from '../components/tourItem';

import { FormattedMessage, useIntl } from "react-intl";
//IMAGE
import create_tour from 'static/img/ts_menu_rideplan.png';
//PROP TYPES
import PropTypes from 'prop-types';
import TransferButton from './transferButton';
import EmptyTabList, { ListWithoutUser } from './emptyTabList';
import { TRASFER_GPS_TABS } from '../../../../constants/transfer.constants';
import { MultiDayTourItem } from '../components/multiDayTourItem';
import InfiniteScroll from "react-infinite-scroller";

const MyTourTab = (props) => {
    const { myTourList, myCheckedList, loadingMyTourList, getMyTourList, setMyCheckedList, isLogin, loginModalOpen, TourBasketDataDelete, getListStyleIE } = props;
    const [len, setLen] = useState(0);

    const tourList = useMemo(
        () => myTourList.map(item => ({ label: <TourItem item={item} TourBasketDataDelete={TourBasketDataDelete} key={item.id} isLinkEnabled />, value: item.id })),
        [myTourList]
    );

    useEffect(() => {
        getMyTourList(0, true);
    }, []);

    useEffect(() => {
        setLen(myTourList.length);
    }, [myTourList.length]);

    return (
        <React.Fragment>
            <div className="listDownlaodTour" style={getListStyleIE(myCheckedList.length)}>
                {loadingMyTourList ?
                    <div style={{ marginTop: '30px' }}>
                        <Spin />
                    </div>
                    :
                    myTourList.length === 0 ?
                        (isLogin() ? <EmptyTabList /> : <ListWithoutUser showLogin={loginModalOpen} />)
                        :
                        <InfiniteScroll
                            pageStart={0}
                            loadMore={(page) => getMyTourList(page)}
                            hasMore={props.myTourLoadMore}
                            loader={
                                <div
                                    className="loader"
                                    key={0}
                                    style={{
                                        width: "100%",
                                        height: "40px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    Loading ...
                                </div>
                            }
                            useWindow={false}
                        >
                            <Checkbox.Group value={myCheckedList} onChange={setMyCheckedList}>
                                {myTourList.map(item => {
                                    if (item.multiDay === true) {
                                        return <MultiDayTourItem item={item} checkedList={myCheckedList} setCheckedList={setMyCheckedList} key={item.id} />
                                    } else {
                                        return (
                                            <Checkbox value={item.id} key={item.id}>
                                                <TourItem item={item} TourBasketDataDelete={TourBasketDataDelete} key={item.id} isLinkEnabled />
                                            </Checkbox>
                                        )
                                    }
                                })}
                            </Checkbox.Group>
                        </InfiniteScroll>
                }
            </div>
            <TransferButton
                hanleClick={() => props.transferRoutes(myTourList, myCheckedList, TRASFER_GPS_TABS.MY_TOURS)}
                isDisabled={myCheckedList.length === 0}
                isDetectedTT={props.isDetectedTT}
            />
        </React.Fragment>
    )
}

MyTourTab.displayName = "MyTourTab";

// MyTourTab.propTypes = {
//     myTourList, 
//     myCheckedList, 
//     loadingMyTourList, 
//     getMyTourList, 
//     setMyCheckedList
// }


export default MyTourTab;